export const SET_SUPPORT_OVERLAY_OPEN = 'SET_SUPPORT_OVERLAY_OPEN';

export default {
  namespaced: true,
  state: {
    supportOverlayOpen: false,
  },
  actions: {
    setSupportOverlayOpen({ commit }, open) {
      commit(SET_SUPPORT_OVERLAY_OPEN, open);
    },
  },
  getters: {},
  mutations: {
    [SET_SUPPORT_OVERLAY_OPEN](state, open) {
      // eslint-disable-next-line no-param-reassign
      state.supportOverlayOpen = open;
    },
  },
};
